const positions = [
    // Red base
    {x: 67, y: 67}, // 0
    {x: 67, y: 116},
    {x: 117, y: 67},
    {x: 117, y: 116},
    // Blue base
    {x: 67, y: 343},
    {x: 67, y: 392},
    {x: 117, y: 343},
    {x: 117, y: 392},
    // Green base
    {x: 343, y: 343},
    {x: 392, y: 392},
    {x: 392, y: 343}, // 10
    {x: 343, y: 392},
    // Yellow base
    {x: 343, y: 67},
    {x: 392, y: 116},
    {x: 392, y: 67},
    {x: 343, y: 116},
    // Map - starting from red field
    {x: 45, y: 200},
    {x: 76, y: 200},
    {x: 107, y: 200},
    {x: 138, y: 200},
    {x: 169, y: 200}, // 20

    {x: 200, y: 169},
    {x: 200, y: 138},
    {x: 200, y: 107},
    {x: 200, y: 76},
    {x: 200, y: 45},
    {x: 200, y: 14},
    // Top 
    {x: 230, y: 14},
    {x: 261, y: 14},
    {x: 261, y: 45},
    {x: 261, y: 76}, // 30
    {x: 261, y: 107},
    {x: 261, y: 138},
    {x: 261, y: 169},

    {x: 291, y: 200},
    {x: 321, y: 200},
    {x: 352, y: 200},
    {x: 383, y: 200},
    {x: 414, y: 200},
    {x: 445, y: 200},
    // Right
    {x: 445, y: 230}, // 40

    {x: 445, y: 261},
    {x: 414, y: 261},
    {x: 383, y: 261},
    {x: 352, y: 261},
    {x: 321, y: 261},
    {x: 291, y: 261},

    {x: 261, y: 291},
    {x: 261, y: 322},
    {x: 261, y: 353},
    {x: 261, y: 384}, // 50
    {x: 261, y: 414},
    {x: 261, y: 445}, 
    // Bottom
    {x: 230, y: 445},

    {x: 200, y: 445},
    {x: 200, y: 414},
    {x: 200, y: 384},
    {x: 200, y: 353},
    {x: 200, y: 322},
    {x: 200, y: 291},
   
    {x: 169, y: 261}, // 60
    {x: 138, y: 261},
    {x: 107, y: 261},
    {x: 76, y: 261},
    {x: 45, y: 261},
 
    {x: 15, y: 261},
    // Left 
    {x: 15, y: 231}, // 66
    // One behind red base
    {x: 15, y: 200}, //67
    // Red end
    {x: 45, y: 231}, // 68
    {x: 76, y: 231},
    {x: 107, y: 231},
    {x: 138, y: 231},
    {x: 169, y: 231},
    {x: 200, y: 231}, // 73
    // Blue end
    {x: 231, y: 414}, // 74
    {x: 231, y: 384},
    {x: 231, y: 353}, 
    {x: 231, y: 322},
    {x: 231, y: 291},   
    {x: 231, y: 260}, // 79
    // Green end
    {x: 414, y: 231}, // 80
    {x: 383, y: 231},
    {x: 352, y: 231},
    {x: 321, y: 231},
    {x: 290, y: 231},
    {x: 259, y: 231}, // 85
    // Yellow base
    {x: 230, y: 45}, // 86
    {x: 230, y: 76}, 
    {x: 230, y: 107},
    {x: 230, y: 138},
    {x: 230, y: 169},
    {x: 230, y: 200}, // 91
];

export default positions;